import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ProductDetailVariants-holder" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variants, (variant, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["ProductDetailVariants-item", { 'is-active': _ctx.selectedVariant.id === variant.id }]),
        key: index,
        onClick: ($event: any) => (_ctx.changeVariant(variant))
      }, [
        _createElementVNode("span", null, _toDisplayString(variant.variant !== "" ? variant.variant : variant.title), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}